import { render, staticRenderFns } from "./CourseHistoryPage.vue?vue&type=template&id=19147523&"
import script from "./CourseHistoryPage.vue?vue&type=script&lang=ts&"
export * from "./CourseHistoryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports